import { formatNumber } from '@local_modules/flokit'

export function formatNumberToContext (value, context) {
  const decimals = Number.isFinite(context?.viewDecimals) ? context?.viewDecimals : 2
  return formatNumber(value, decimals)
}
